export const dateTimeZone = "Europe/Prague";
